import React from "react";

import HeroSection from "./Component/HeroSection";
import ProjectSection from "./Component/ProjectSection";
import NextSection from "./Component/NextSection";
import DummySection from "./Component/DummySection";
import ReactSection from "./Component/ReactSection";
import JsSection from "./Component/JsSection";

import "./css/general.css";
import "./css/logo-btn.css";
import "./css/my-name.css";
import "./css/nav.css";
import "./css/style.css";
import "./css/queries.css";

const Home = () => {
  return (
    <>
      <main>
        {/* Hero Section */}
        <HeroSection />

        {/* Project Section */}
        <ProjectSection sectionHeading="Recents" sectionID="projects" />

        {/* Next Section */}
        <NextSection sectionHeading="Next JS Apps" sectionID="next" />

        {/* Dummy Section */}
        <DummySection sectionHeading="Dummy Websites" sectionID="dummy" />

        {/* React Section */}
        <ReactSection sectionHeading="React JS Apps" sectionID="react" />

        {/* JS Section */}
        <JsSection sectionHeading="JavaScript Apps" sectionID="js" />
      </main>
    </>
  );
};

export default Home;
